<template>
  <div class="overflow-x-scroll">
    <!-- Table -->
    <div class="table-responsive">
      <table class="table table-bordered table-hover align-middle text-center">
        <thead class="table-light">
          <tr>
            <th class="text-start" style="min-width: 180px">Product</th>

            <th
              v-for="m in months"
              :key="m.key"
              style="min-width: 90px"
            >
              {{ m.label }}
            </th>

            <th style="min-width: 110px">Total Target</th>
            <!-- <th style="min-width: 120px">Total Achieved</th> -->
            <th style="min-width: 120px">Action</th>
          </tr>
        </thead>

      <tbody v-if="localTable.length">
  <tr
    v-for="row in localTable"
    :key="row.id"
  >
    <!-- Product -->
    <td class="text-start">
      <div style="font-weight: 500;">
        {{ row.product }}
      </div>
    </td>

    <!-- Monthly Targets -->
    <td
      v-for="m in months"
      :key="m.key"
    >
      <template v-if="row.editing">
        <input
          v-model.number="row.targets[m.key]"
          type="number"
          min="0"
          class="form-control form-control-sm text-center"
          style="min-width: 70px"
        />
      </template>

      <template v-else>
        {{ formatNumber(row.targets[m.key] ?? '—') }}
      </template>
    </td>

    <!-- Total Target -->
    <td>
      <span class="text-primary metric-badge metric-target">
        {{ formatNumber(row.total_target) }}
      </span>
    </td>

    <!-- Actions -->
    <td>
      <div class="d-flex justify-content-center" style="gap: 6px;">
        <!-- Edit -->
        <button
          v-if="!row.editing"
          class="btn btn-sm btn-outline-primary"
          @click="editRow(row)"
          v-b-tooltip.hover
          title="Edit"
        >
          <i class="fa fa-edit"></i>
        </button>

        <!-- Save -->
        <button
          v-else
          class="btn btn-sm btn-success"
          @click="saveRow(row)"
          v-b-tooltip.hover
          title="Save"
        >
          <i class="fa fa-save"></i>
        </button>

        <!-- Cancel -->
        <button
          v-if="row.editing"
          class="btn btn-sm btn-outline-secondary"
          @click="cancelEdit(row)"
          v-b-tooltip.hover
          title="Cancel"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
    </td>
  </tr>
</tbody>

<!-- No Data -->
<tbody v-else>
  <tr>
    <td
      :colspan="months.length + 3"
      class="py-5 text-center"
    >
      <div class="d-flex flex-column align-items-center text-muted">
        <i
          class="mb-2 fa fa-database"
          style="font-size: 2rem;"
        ></i>

        <h6 class="mb-1">No Data Found</h6>

        <small>
          No target data available for selected filters
        </small>
      </div>
    </td>
  </tr>
</tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    table: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      months: [
        { key: 1, label: 'Jan' },
        { key: 2, label: 'Feb' },
        { key: 3, label: 'Mar' },
        { key: 4, label: 'Apr' },
        { key: 5, label: 'May' },
        { key: 6, label: 'Jun' },
        { key: 7, label: 'Jul' },
        { key: 8, label: 'Aug' },
        { key: 9, label: 'Sep' },
        { key: 10, label: 'Oct' },
        { key: 11, label: 'Nov' },
        { key: 12, label: 'Dec' },
      ],

      localTable: [],
    };
  },

  watch: {
    table: {
      immediate: true,
      deep: true,

      handler(val) {
        this.localTable = val.map(item => ({
          ...JSON.parse(JSON.stringify(item)),
          editing: false,
          backupTargets: {},
        }));
      },
    },
  },

  methods: {
    formatNumber(value) {
      return Number(value || 0).toLocaleString();
    },
    editRow(row) {
      row.backupTargets = JSON.parse(
        JSON.stringify(row.targets)
      );

      row.editing = true;
    },

    cancelEdit(row) {
      row.targets = JSON.parse(
        JSON.stringify(row.backupTargets)
      );

      row.editing = false;
    },

    saveRow(row) {
      const payload = {
        product: row.product,
        targets: row.targets,
        team:  row.team,
        year: row.year
      };

      this.$emit('save', payload);

      row.editing = false;
    },
  },
};
</script>


<style scoped>
/* Wrapper */
.table-responsive {
  border-radius: 18px;
  overflow-x: scroll;
  background: #ffffff;
  box-shadow: 0 8px 28px rgba(244, 47, 101, 0.08);
  border: 1px solid #bfb9f3;
}

/* Table */
table {
  margin-bottom: 0;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 1200px;
  background: #fff;
}

/* Header */
thead {
  background: linear-gradient(135deg, #7C70FF 0%, rgb(85, 64, 241) 100%);
}

thead th {
  color: #fff;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border: none !important;
  padding: 16px 12px;
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 2;
}

/* Body */
tbody tr {
  transition: all 0.2s ease;
  background: #fff;
}

tbody tr:nth-child(even) {
  background: #dad6ff5e;
}

tbody tr:hover {
  background: #ffe4ea;
  transform: scale(1.002);
}

/* Table Cells */
tbody td {
  padding: 14px 10px;
  vertical-align: middle;
  border-color: #bfb9f3 !important;
  font-size: 0.84rem;
  color: #444;
}

/* Product Name */
tbody td:first-child {
  font-weight: 600;
  color: #2d2d2d;
}

/* Monthly Value */
tbody td:not(:first-child) {
  font-weight: 500;
}

.text-primary {
  color: #2563eb !important;
  font-weight: 700 !important;
}

/* Total Achieved */
.text-success {
  color: #16a34a !important;
  font-weight: 700 !important;
}

/* Badge Style */
.metric-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-radius: 999px;
  min-width: 85px;
  font-size: 0.8rem;
}

.metric-target {
  background: rgba(37, 99, 235, 0.1);
}

.metric-achieved {
  background: rgba(22, 163, 74, 0.1);
}

/* Inputs */
input.form-control-sm {
  border-radius: 10px;
  border: 1px solid #ffd0da;
  background: #fff;
  height: 34px;
  font-size: 0.82rem;
  font-weight: 600;
  transition: all 0.2s ease;
}

input.form-control-sm:focus {
  border-color: #F42F65;
  box-shadow: 0 0 0 3px rgba(244, 47, 101, 0.15);
  background: #fff;
}

/* Buttons */
.btn-sm {
  border-radius: 10px;
  width: 34px;
  height: 34px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

/* Edit */
.btn-outline-primary {
  border: 1px solid #F42F65;
  color: #F42F65;
  background: #fff;
}

.btn-outline-primary:hover {
  background: #F42F65;
  color: #fff;
  transform: translateY(-1px);
}

/* Save */
.btn-success {
  background: linear-gradient(135deg, #16a34a, #22c55e);
  border: none;
}

.btn-success:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.25);
}

/* Cancel */
.btn-outline-secondary {
  border: 1px solid #d1d5db;
  color: #6b7280;
}

.btn-outline-secondary:hover {
  background: #6b7280;
  color: #fff;
}

/* Scrollbar */
.overflow-x-scroll::-webkit-scrollbar {
  height: 8px;
}

.overflow-x-scroll::-webkit-scrollbar-track {
  background: #ffe4ea;
  border-radius: 20px;
}

.overflow-x-scroll::-webkit-scrollbar-thumb {
  background: #F42F65;
  border-radius: 20px;
}

.overflow-x-scroll::-webkit-scrollbar-thumb:hover {
  background: #d91e56;
}

/* Rounded corners */
thead th:first-child {
  border-top-left-radius: 18px;
}

thead th:last-child {
  border-top-right-radius: 18px;
}

/* Empty Value */
tbody td template {
  color: #999;
}

/* Mobile */
@media (max-width: 768px) {
  thead th,
  tbody td {
    padding: 10px 8px;
    font-size: 0.74rem;
  }

  .btn-sm {
    width: 30px;
    height: 30px;
  }
}
</style>
